import { createFileRoute } from '@tanstack/react-router'
import { noop } from '@tanstack/react-query'
import { trpc } from '@/main'

// Pathless layout that OWNS the query-keyed reads, so a new query, range or zoom re-keys THIS match and not the page
// above it, which would repaint its skeleton over the toolbar. The page reads them with `useMatch({ from })`. The rows and
// the sessions are two views of one query: only the one on screen is warmed.
export const Route = createFileRoute('/_app/admin/logs/_list')({
  loaderDeps: ({ search }) => ({
    q: search.query,
    range: search.range,
    from: search.from,
    to: search.to,
    view: search.view,
    live: search.live,
  }),
  context: ({ deps }) => {
    const window = { q: deps.q, range: deps.range, from: deps.from, to: deps.to, live: deps.live }
    const input = { dataset: deps.view === 'all' ? ('logs' as const) : ('console' as const), ...window }
    return {
      // The live tail's input: what it polls past the newest row is the rows' own query.
      logInput: input,
      logRowsInfiniteQueryOptions: trpc.admin.searchLogs.infiniteQueryOptions(input, {
        getNextPageParam: (lastPage) => (lastPage.store === 'ok' ? lastPage.nextCursor : undefined),
      }),
      logSessionsQueryOptions: trpc.admin.listConsoleSessions.queryOptions(window),
      logHistogramQueryOptions: trpc.admin.logHistogram.queryOptions(input),
      logFacetsQueryOptions: trpc.admin.logFacets.queryOptions(input),
    }
  },
  loader: ({ context, deps }) => {
    if (deps.view === 'sessions') context.queryClient.query(context.logSessionsQueryOptions).catch(noop)
    else context.queryClient.infiniteQuery(context.logRowsInfiniteQueryOptions).catch(noop)
    context.queryClient.query(context.logHistogramQueryOptions).catch(noop)
    context.queryClient.query(context.logFacetsQueryOptions).catch(noop)
  },
})
